import { useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useCustomer } from './useCustomer';

export interface UserLogin {
    email: string;

    password: string;

    rememberMe?: boolean;
}

export interface LoginMutationVariables {
    userLogin: UserLogin;
}

export const useLoginMutation = (): UseMutationResult<unknown, unknown, LoginMutationVariables> => {
    const customer = useCustomer();
    return useMutation<unknown, unknown, LoginMutationVariables>({
        mutationFn: async ({ userLogin }) => {
            await customer.login(userLogin);
        },
    });
};
